module.exports = __webpack_public_path__ + "img/map-marker.90971c1c.svg";